// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_LIq","top":"styles_top__16t_q"};